'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tabs/style/css.js
// module id = yW9+
// module chunks = 0